module.exports = {"id":"165429","name":"Claudiu Keşerü","rating":"73","photo":"./data/images/photos/3/165429.png","club":{"name":"Agents libres","logo":"./data/images/clubs/Agentslibres.png"},"positions":["BU","ATT","AG"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/ClaudiuKeseru0.json
// module id = 834
// module chunks = 0